import { PostVerifyGoods } from '@/utils/http/modules/agent/order'
import { PostOperateAgentInteger } from '@/utils/http/modules/agent/integer'
import $agent_api, {
  cacheShareLink,
  agentIsGray,
} from '@/utils/http/modules/agent/agent.request'
import { Ddebounce, getUrlParam, $clone, getMyCookie } from '@/utils/utils'
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import moment from 'moment'
import { computed } from 'vue'
import { mapGetters } from 'vuex'
import useIntegral from '@/utils/useIntegral.js'
import { getAuditRecordCount } from '@/utils/http/modules/memberPoints/memberPoints.request'
import { webLog } from '@/plugin/webLog'

export const agentOrderMixins = {
  data() {
    return {
      currentChildItem: {},
      confirmVerifyDialogShow: false,
      inputVerifyNum: '',
      operateType: '',
      childIndex: 0,
      curIndex: 0,
      verifyTimer: null,
      showVerifyTips: false,
      agentVerifyData: {},
      handleItem: {},
      verifyLoading: false,
    }
  },
  computed: {
    ...mapGetters(['getAuthDataAndAgentSetting', 'userInfo']),
    isCheckOrder() {
      return this.$route.meta.fromType == 'checkorder'
    },
    isStore() {
      return StoreController.isStore(this)
    },
    // 是否是代理 并且 路由是代理页面
    isAgentAndAgentPage() {
      return (
        this.getAuthDataAndAgentSetting &&
        this.getAuthDataAndAgentSetting.isAgent &&
        window.location.pathname.indexOf('/agent/') > -1
      )
    },
  },
  methods: {
    viewOrderDetails(row) {
      let path = this.isStore ? '/store/checkorder' : '/order/checkorder'
      this.$router.push({
        path: path,
        query: {
          oid: row.id || row.orderId,
          // tpid: row.topicId || 0,
          zbid: row.tenantId || 0,
          fromType: 'agent',
          entryType: getUrlParam('entryType'),
          isAgentAndAgentPage: Number(this.isAgentAndAgentPage),
        },
      })
    },
    async handleVerifyGoods(type, item, index, cIndex, remainCodeNum) {
      if (item.isWeight && this.fromType !== 'landBill') {
        if (item.verifyUrl) {
          location.href = item.verifyUrl
        } else {
          this.$toast('verifyUrl为空')
        }
        return
      }
      this.operateType = type
      this.curIndex = index
      this.handleItem = item
      if (type == 'all') {
        this.handleAllVerify(item, '', remainCodeNum)
      } else {
        try {
          let title = ''
          let message = '确定核销该商品吗'
          if (item.isWeight && item.weightIsCredited) {
            title = '确定核销该商品吗'
            message = '(需要多退少补的订单的称重将被自动赋值为下单重量)'
          }
          await this.$dialog.confirm({
            title,
            message,
            confirmButtonColor: '#006cff',
          })
          this.childIndex = cIndex
          this.currentChildItem = item
          if (item.remainVerifyNumber == 1 || item.isWeight) {
            this._PostVerifyGoods(this.formatParams('', this.currentChildItem))
          } else {
            this.inputVerifyNum = ''
            this.confirmVerifyDialogShow = true
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    formatParams(type, item) {
      this.operateType = type
      if (type == 'all') {
        return {
          list: (item.detailLs || item.orderDetails)
            .map(dItem => {
              return {
                OrderDetailId: dItem.id,
                UseAmount: dItem.remainVerifyNumber,
                code: '',
              }
            })
            .filter(item => item.UseAmount > 0),
          verifyType: 5,
        }
      } else {
        return {
          list: [
            {
              OrderDetailId: item.id,
              UseAmount: item.remainVerifyNumber,
              code: '',
            },
          ],
          verifyType: 5,
        }
      }
    },
    handleVerifyNumConfirm() {
      this.operateType = ''
      if (!this.inputVerifyNum) {
        return this.$toast('请输入你要核销的数量')
      }
      if (Number(this.inputVerifyNum) < 1) {
        this.inputVerifyNum = 1
        return this.$toast('当前核销数量不能小于1')
      }
      if (this.inputVerifyNum > this.currentChildItem.remainVerifyNumber) {
        this.inputVerifyNum = this.currentChildItem.remainVerifyNumber
        return this.$toast(
          '当前核销数量不能大于' + this.currentChildItem.remainVerifyNumber
        )
      }
      this._PostVerifyGoods(
        this.formatParams('', {
          ...this.currentChildItem,
          remainVerifyNumber: this.inputVerifyNum,
        })
      )
    },
    // 核销订单
    _PostVerifyGoods: Ddebounce(
      async function (params, type = '') {
        if (this.verifyLoading) return
        try {
          this.verifyTimer && clearTimeout(this.verifyTimer)
          if (type == 'confirm') {
            params = Object.assign({}, params, { confirm: true })
          }
          if (
            this.set_code_verify_new_special_params &&
            this.set_code_verify_new_special_params.toString() ===
              '[object Object]'
          ) {
            params = {
              ...params,
              ...this.set_code_verify_new_special_params,
            }
          }
          // if (this.fromType === 'landBill') {
          //   params = { ...params, isBatchTask: false }
          // }
          // 改为全部加isBatchTask字段
          params = { ...params, isBatchTask: false }
          this.verifyLoading = true
          params.currentZbId = window.zbvd.zbid || this.$route.query.zbid
          params.tenantId = window.zbvd.zbid || this.$route.query.zbid
          webLog({
            title: '用户自助核销【商品】调用接口之前',
            cookie: getMyCookie() || '',
            userId: this.userInfo.id,
            time: new Date(),
            url: window.location.href,
            data: params,
          })
          const res = await PostVerifyGoods(params)
          if (res.isok && res.code == 0) {
            this.$toast('核销成功！')
            this.showVerifyTips = false
            this.verifyLoading = false
            this.verifyTimer = setTimeout(() => {
              if (this.isCheckOrder) {
                this.getOrderData()
              } else {
                this.handleSearch && this.handleSearch()
              }
            }, 800)
            this.confirmVerifyDialogShow = false
          } else {
            this.showVerifyTips = false
            this.verifyLoading = false
            this.$toast(res.msg || '请求失败')
          }
        } catch (e) {
          this.showVerifyTips = false
          if (e.code == 4458) {
            this.agentVerifyData = e.dataObj
            this.showVerifyTips = true
          } else {
            this.$toast(typeof e == 'string' ? e : e.msg)
          }
          this.verifyLoading = false
        }
      },
      1200,
      true
    ),
    async handleAllVerify(item, type = '', remainCodeNum = 0) {
      let message = `确定要核销该订单中的全部商品吗？${
        remainCodeNum > 0 ? `\n剩余${remainCodeNum}个未核销` : ''
      }`
      if (item.detailLs?.[0]?.isWeight && item.weightIsCredited) {
        message += '(需要多退少补的订单的称重将被自动赋值为下单重量)'
      }
      await this.$dialog.confirm({
        title: '全部核销',
        message,
        confirmButtonColor: '#006cff',
      })
      this._PostVerifyGoods(this.formatParams('all', item), type)
    },
    formatCustomQuery() {
      for (let i in this.customQuery) {
        this.$set(this.customQuery, i, undefined)
      }
    },
    confirmVerify: Ddebounce(function () {
      this._PostVerifyGoods(
        this.formatParams(this.operateType, {
          ...this.handleItem,
          remainVerifyNumber: this.inputVerifyNum || 1,
        }),
        'confirm'
      )
    }, 800),
  },
}

export const agentIntegerMixins = {
  data() {
    return {
      confirmIntegerDialogShow: false,
      integerTriggerType: '',
      integerOptions: {},
      integerInputNum: 1,
      integerTimer: null,
      integralName: '积分',
      auditNum: 0,
      reason: '',
      auditShow: false,
    }
  },
  created() {
    this.getIntegralName()
  },
  computed: {
    needAudit({ agentSetting }) {
      return (
        agentSetting &&
        agentSetting.sendIntegralRequireReview &&
        !window.userInfo?.roles?.find(v => v == 'ADMIN' || v == 'CREATOR')
      )
    },
  },
  methods: {
    async getIntegralName() {
      let res = await useIntegral()
      this.integralName = res?.title || '积分'
    },
    async handleTriggerInteger(type) {
      this.integerTriggerType = type
      this.confirmIntegerDialogShow = true
      this.integerInputNum = 1
      if (type == 'cost') {
        this.integerOptions = {
          title: `消耗${this.integralName}`,
          placeholder: `请输入要消费的${this.integralName}`,
        }
      } else if (type == 'send') {
        if (this.needAudit) {
          const res = await getAuditRecordCount({
            zbId: window.zbvd.zbid,
            userId: this.changeAgentItem?.customerId || this.listQuery?.userId,
          })
          this.auditNum = res.dataObj
          this.reason = ''
        }
        this.integerOptions = {
          title: `发送${this.integralName}`,
          placeholder: `请输入要发送的${this.integralName}`,
        }
      }
    },
    handleIntegerConfirm: Ddebounce(
      async function (zbid, userid) {
        if (!this.integerInputNum || this.integerInputNum == 0) {
          return this.$toast(
            `请输入${
              this.integerTriggerType == 'cost' ? '要消费的' : '要发送的'
            }积分`
          )
        }
        if (this.integerInputNum > 100000) {
          this.integerInputNum = 100000
          return this.$toast(
            `单次最多${
              this.integerTriggerType == 'cost' ? '消费' : '发送'
            }10万积分`
          )
        }
        if (
          this.integerTriggerType == 'send' &&
          this.needAudit &&
          !this.reason
        ) {
          return this.$toast('请输入申请理由')
        }
        try {
          const res = await PostOperateAgentInteger({
            zbid,
            userid,
            operatetype: this.integerTriggerType == 'cost' ? 2 : 1,
            integralnum: this.integerInputNum,
            reason: this.integerTriggerType == 'send' ? this.reason : undefined,
          })
          if (res.code == 0 && res.isok) {
            this.handleSearch && this.handleSearch()
            this.$emit('update')
            this.confirmIntegerDialogShow = false
            this.integerTimer = setTimeout(() => {
              this.$toast(res.msg)
              this.integerTimer && clearTimeout(this.integerTimer)
            }, 800)
          } else {
            this.$toast(res.msg)
          }
        } catch (e) {
          console.log(e)
          this.$toast(typeof e == 'string' ? e : e.msg)
        }
      },
      1000,
      true
    ),
  },
}

export const agentCommonInfoMixins = {
  data() {
    return {
      formatLevelList: [],
      agentGray: false,
      validityLinkShareInfo: {},
      validityLinkParams: {
        lt: '',
      },
      shareType: 0, // 0栏目课程 1栏目预告
      validityLinkSetPopup: false,
    }
  },
  methods: {
    async fetchGetAgentAuth(callback) {
      try {
        const res = await $agent_api.getAgentAuth({ zbId: window.zbvd.zbid })
        if (res.code == 0) {
          typeof callback === 'function' && callback(res.dataObj)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchGetAgentSetting(callback) {
      try {
        const { dataObj } = await $agent_api.getAgentSetting({
          zbId: window.zbvd.zbid,
        })
        typeof callback === 'function' && callback(dataObj)
      } catch (e) {
        e && this.$toast(e)
      }
    },
    handleLevelDisplay(callback, authData, agentSetting) {
      this.formatLevelList = [
        { value: '', name: '全部' },
        ...agentSetting.level
          .map(item => {
            return {
              value: item.index,
              name: item.levelName,
            }
          })
          .reverse(),
      ]
      function logicWay(level, cItem) {
        if (level == 1) {
          return cItem.value == 1
        } else {
          return cItem.value < level
        }
      }
      if (authData.isAgent || authData.isRole) {
        this.formatLevelList = this.formatLevelList.filter(cItem =>
          logicWay(authData.level, cItem)
        )
        typeof callback === 'function' && callback(this.formatLevelList)
      }
      if (this.$store.getters.getAuthDataAndAgentSetting.isAdminNotAgent) {
        typeof callback === 'function' && callback(this.formatLevelList)
      }
    },
    getValidityLinkParam() {
      return `${
        this.validityLinkParams.lt ? `&lt=${this.validityLinkParams.lt}` : ''
      }`
    },
    async _agentIsGray() {
      try {
        const { dataObj } = await agentIsGray({
          businessType: 1,
          zbId: this.$route.query.zbid * 1 || window.zbvd.zbid * 1,
        })
        this.agentGray = dataObj
      } catch (e) {
        e && this.$toast(e)
      }
    },
    async _cacheShareLink(options) {
      try {
        const { dataObj } = await cacheShareLink(options)
        this.validityLinkParams.lt = dataObj
      } catch (e) {
        e && this.$toast(e)
      }
    },
  },
}

export const agentOverYears = {
  data() {
    return {
      OverYears: [],
      ParamsStr: '',
      YearsStr: '',
    }
  },
  computed: {
    hasOverYears() {
      return this.OverYears.length > 0
    },
  },
  methods: {
    clearOverYears() {
      this.OverYears = []
    },
    updateOverYearsNoMore(dataObj, size) {
      if (
        !Array.isArray(dataObj) ||
        (Array.isArray(dataObj) && dataObj.length < size)
      ) {
        const index = this.OverYears.findIndex(item => item.nomore == false)
        if (index > -1) {
          this.OverYears[index].nomore = true
          return true
        }
      }
      return false
    },
    checkOverYears(params) {
      const { endTime, startTime } = params
      // 查询参数有更新
      const pdata = $clone(params)
      delete pdata.pageIndex
      delete pdata.startTime
      delete pdata.endTime
      // 缓存年份
      if (this.YearsStr) {
        if (this.YearsStr != `${startTime}-${endTime}`) {
          this.YearsStr = `${startTime}-${endTime}`
          this.OverYears = []
        }
      } else {
        this.YearsStr = `${startTime}-${endTime}`
      }
      // 缓存参数
      if (this.ParamsStr == '') {
        this.ParamsStr = JSON.stringify(pdata)
      } else {
        const newp = JSON.stringify(pdata)
        console.log(this.ParamsStr != newp)
        console.log(this.ParamsStr, newp)
        if (this.ParamsStr != newp) {
          this.ParamsStr = newp
          this.OverYears = []
        }
      }
      // 判断endTime, startTime是否存在跨年
      if (
        endTime &&
        startTime &&
        moment(endTime).year() != moment(startTime).year()
      ) {
        if (this.OverYears.length == 0) {
          const range1 = [
            moment(endTime).startOf('year').format('YYYY-MM-DD'),
            moment(endTime).format('YYYY-MM-DD'),
          ]
          const range2 = [
            moment(startTime).format('YYYY-MM-DD'),
            moment(startTime).endOf('year').format('YYYY-MM-DD'),
          ]
          this.OverYears = [
            {
              nomore: false,
              time: range1,
            },
            {
              nomore: false,
              time: range2,
            },
          ]
        }
        const range = this.OverYears.find(item => item.nomore == false)
        if (range) {
          const [startTime, endTime] = range.time
          params.startTime = startTime
          params.endTime = endTime
        }
      } else {
        this.OverYears = []
        this.YearsStr = ''
        this.ParamsStr = ''
      }
      return params
    },
  },
}
